import type { WorkplaceRequestTypeElement } from "@gettactic/api";

/** The parts of a request type these predicates need. */
type KindBearing = Pick<Partial<WorkplaceRequestTypeElement>, "kind">;

/**
 * A signpost type: instructions replace the form entirely, and nothing is filed
 * in Tactic. Approval, assignment, statuses, workflows and notifications do not
 * apply to it and are not rendered.
 *
 * Prefer this over comparing `kind` inline — every surface that shows, counts or
 * files request types has to agree on the question, and a stray `=== "default"`
 * silently answers it the other way for a type whose kind is missing.
 */
export const isInformationRequestType = (type: KindBearing): boolean =>
  type.kind === "information";

/** A type an employee can actually submit — i.e. one that files a ticket. */
export const isSubmittableRequestType = (type: KindBearing): boolean =>
  !isInformationRequestType(type);
